module.exports = __webpack_public_path__ + "367fdffb6bac107cea7562d55ebd28fb.svg";